var $ = require('jquery');
var _ = require('lodash');
var componentMapper = require('./component-mapper');
var getSymbolFromCurrency  = require('currency-symbol-map');
var MapConfig = require('./googleMapConfig');
var Constants = require('libs/constants');
var MarkerClusterer = require('marker-clusterer-plus');

var properties = {
  isInfoWindowPersist: false,
  markers: [],
  markerData: {
    properties: [],
    imageUrl: {},
    isAddressPin: false
  },
  mapControls: {
    streetViewControl: MapConfig.mapProps.streetViewControl,
    style: MapConfig.mapProps.zoomControlOptions.style,
    position: MapConfig.mapProps.zoomControlOptions.position
  },
  locations: {},

  /**
  * This function is used to render google map.
  * @return void
  **/
  renderGoogleMap: function() {
    var dataArray = this.markerData.properties;
    var propLen = dataArray.length;
    //setting Map Center
    MapConfig.mapProps.center = {
      lat: propLen ? Number(dataArray[0].lat) : MapConfig.defaultLat,
      lng: propLen ? Number(dataArray[0].longitude) : MapConfig.defaultLong
    };
    // setting Map Zoom Level
    MapConfig.mapProps.zoom = propLen ? MapConfig.markerZoomLevel : MapConfig.defaultZoomLevel;
    MapConfig.mapProps.streetViewControl = this.markerData.isHotelPin ? MapConfig.noStreetViewControl : this.mapControls.streetViewControl;
    MapConfig.mapProps.zoomControlOptions.style = this.mapControls.style;
    MapConfig.mapProps.zoomControlOptions.position = this.mapControls.position;

    MapConfig.mapProps.draggable = this.markerData.isMapDraggable;
    MapConfig.mapProps.noClear = this.markerData.isMapNoClear;
    MapConfig.mapProps.scrollwheel = this.markerData.isScrollwheel;
    if(this.$el.closest('.l-promo-property-records').length){
      MapConfig.mapProps.gestureHandling = this.markerData.gestureHandling;
    }
    window.googleMaps = new google.maps.Map(this.$el.get(0), MapConfig.mapProps);
  },

  /**
  * This function is used to return the latitude and longitude object
  * @return void
  **/
  createLatLngObject: function(lat, lng) {
    return new google.maps.LatLng(Number(lat), Number(lng));
  },

  /**
  * This function is used to render google map markers.
  * @return void
  **/
  renderMarkers: function() {
    var _self = this;
    _self.locations = new google.maps.LatLngBounds();
    _self.omsList = new this.oms(window.googleMaps, MapConfig.markerOMSOptions);

    //overriding marker's img urls path
    MapConfig.markerProps.icon.url = _self.markerData.imageUrl.pinImg;
    MapConfig.markerProps.propertyTypes = _self.markerData.propertyTypes;
    MapConfig.markerProps.propertyMarker = _self.markerData.propertyMarker;
    MapConfig.markerProps.propertyBedMarkerLabel = _self.markerData.propertyBedMarkerLabel;

    if(_self.markerData.isHotelPin) {
      MapConfig.markerProps.hotelIcon.url = _self.markerData.imageUrl.pinImg;
    }
		var dir = document.getElementsByTagName("html")[0].getAttribute("dir");
		if(dir === 'rtl'){
			MapConfig.markerProps.icon.labelOrigin = new google.maps.Point(18, 12);
		}
    if(_self.markerData.properties[0].isHwsPin){
      MapConfig.markerProps.icon.size = new google.maps.Size(_self.markerData.size.x,_self.markerData.size.y);
      MapConfig.markerProps.icon.origin = new google.maps.Point(0, MapConfig.pushPinSpritePoint[_self.markerData.propertyCode]);
      MapConfig.markerProps.icon.anchor = new google.maps.Point(_self.markerData.anchor.x,_self.markerData.anchor.y);
      delete MapConfig.markerProps.icon.scaledSize;
    }
    if(_self.markerData.showCityCenter) {
      var cityCenterPos = _self.createLatLngObject(_self.markerData.cityCenter.latitude, _self.markerData.cityCenter.longitude);
      _self.createCityCenter(cityCenterPos);
    }
    _self.markers = _self.markerData.properties.map(function(propertyData, i) {
      if(!propertyData.isDuplicate) {
        var pos = _self.createLatLngObject(propertyData.lat, propertyData.longitude);
        var markerLbl;
        if(_self.markerData.isHotelPin) {
          markerLbl = propertyData.hotelName.slice(0,MapConfig.markerProps.hotelLength);
          if(propertyData.hotelName.length > MapConfig.markerProps.hotelLength) {
            markerLbl = markerLbl +'...';
          }
        } else {
          markerLbl = propertyData.points || (propertyData.symbol && getSymbolFromCurrency(propertyData.symbol) || "") + (propertyData.price || "");
        }
        if(parseFloat(propertyData.lat) && parseFloat(propertyData.longitude)) {
          _self.locations.extend(pos);
        }
        return _self.createMarker(pos, i, markerLbl);
      }
    });

    if(_self.markerData.duplicateArrayList) {
      _self.duplicateMarkers = _self.markerData.duplicateArrayList.map(function(propertyData, i) {
        return _self.createDuplicateMarker(propertyData.split(","));
      });
    }


    if(_self.markerData.isAddressPin) {
      var addressMarker = new google.maps.Marker({
        position: _self.createLatLngObject(_self.markerData.searchLat, _self.markerData.searchLong),
        map: window.googleMaps,
        icon:{
          url: _self.markerData.imageUrl.pinAdd,
          size: MapConfig.addressPinDimension,
					scaledSize: new google.maps.Size(33, 33)
        },
        isAddressPin: true
      });
      google.maps.event.addListener(addressMarker, 'mouseover', this.markerMouseOverHandler.bind(this, addressMarker));
      google.maps.event.addListener(addressMarker, 'mouseout',  this.markerMouseOutHandler.bind(this, addressMarker));
    }

    _self.omsList.addListener('click', function(marker,event) {
      if(marker.markerIndex.length){
        var element= $(event.target).data('propindex');
        var markerArrayIndex = marker.markerIndex.indexOf(element);
      }
      _self.markerClickHandler.call(_self,marker,event,markerArrayIndex);
    });
  },

  /**
  * This function is used to create a marker and to bind its event.
  * @return {Object} google map marker Object
  **/
 createMarker: function(pos, index, markerLabel) {
    var _self = this;

    if(MapConfig.customControl) {
      return  _self.createMarkerWithLabel(pos, index, markerLabel)
    } else {
      if(!markerLabel) {
        MapConfig.markerProps.icon.scaledSize = MapConfig.blankPinDimension;
      }
      var marker = new google.maps.Marker({
          position: pos,
          label: {
            color: MapConfig.markerProps.color,
            text: markerLabel ? markerLabel : " ",
            fontSize: "1rem"
          },
          icon: MapConfig.markerProps.icon,
          markerIndex: index,
          visible: !this.markerData.hideMarker,
          cursor: this.markerData.cursor
        });
  
      this.omsList.addMarker(marker);
      google.maps.event.addListener(marker, 'mouseover', this.markerMouseOverHandler.bind(this, marker));
      google.maps.event.addListener(marker, 'mouseout',  this.markerMouseOutHandler.bind(this, marker));
  
      return marker;
    } 
  },

  /**
  * This function is used to create a city center marker and to bind its event.
  * @return {Object} google map marker Object
  **/
 createCityCenter: function(pos) {
  var cityMmarker = new this.markerWithLabel({
    position: pos,
    map: window.googleMaps,
    icon: ""
});

},

  /**
  * This function is used to create a custom marker and to bind its event.
  * @return {Object} google map marker Object
  **/
 createMarkerWithLabel: function(pos, index, markerLabel) {

  var _self = this,marker,propertyBedIcon,propertyTypeLabelClass,
  propertyTypeLabel = this.markerData.properties[index].propertyType || '';
  propMarkerLabel = this.markerData.properties[index].propMarkerLabel;
  propertyBedMarkerLabel = this.markerData.properties[index].propMarkerBedLabel;
  
  if(MapConfig.markerProps.propertyTypes){
    propertyTypeLabelClass = Object.keys(MapConfig.markerProps.propertyTypes).find(function(key){
      return MapConfig.markerProps.propertyTypes[key] === propertyTypeLabel ? true : false;
    }) || 'default';
  }else {
    propertyTypeLabelClass = 'default';
  }

  if(MapConfig.markerProps.propertyBedMarkerLabel && MapConfig.markerProps.propertyBedMarkerLabel['openingSoonUpperCaseLabel'] == propertyBedMarkerLabel) {
    propertyTypeLabelClass += ' ' + 'openingSoonUpperCaseLabel';
  } else if(MapConfig.markerProps.propertyBedMarkerLabel && MapConfig.markerProps.propertyBedMarkerLabel['callToBookUpperCaseLabel'] == propertyBedMarkerLabel) {
    propertyTypeLabelClass += ' ' + 'callToBookUpperCaseLabel';
  } else if(MapConfig.markerProps.propertyMarker && MapConfig.markerProps.propertyMarker['unavailableUpperCaseLabel'] == propMarkerLabel) {
    markerLabel = propMarkerLabel;
    propertyTypeLabelClass += ' ' + 'unavailableUpperCaseLabel';
  } else if(!markerLabel) {
    propertyTypeLabelClass += ' blank';
    markerLabel = '';
  }
 
  if(!markerLabel) {
    MapConfig.markerProps.icon.scaledSize = MapConfig.blankPinDimension;
  }
  
  marker = new this.markerWithLabel({
      position: pos,
      map: window.googleMaps,
      labelContent: '<div class="map-marker map-marker-'+ propertyTypeLabelClass +'"><span class="room-type m-merch-shape-3 m-merch-style-1">'+propertyTypeLabel+'</span><div class="map-rate-details t-bg-standard-90 t-border-standard-10 t-border-color-standard-20">'+markerLabel +'<span class="t-icon-bedding t-color-standard-20"></span></div><div class="arrow t-bg-standard-standard-100 t-border-right t-border-bottom t-border-color-standard-20"></div></div>',
      icon :{
          path: google.maps.SymbolPath.CIRCLE,
          scale: 0
      },
      labelAnchor: new google.maps.Point(40,40),
      markerIndex: index,
      visible: !this.markerData.hideMarker,
      cursor: this.markerData.cursor,
      labelClass: "markerLabels"
  });
  this.omsList.addMarker(marker);
  google.maps.event.addListener(marker, 'mouseover', this.markerMouseOverHandler.bind(this, marker));
  google.maps.event.addListener(marker, 'mouseout',  this.markerMouseOutHandler.bind(this, marker));

  return marker;
},

/**
  * This function is used to create a custom marker and to bind its event.
  * @return {Object} google map marker Object
  **/
 createDuplicateMarker: function(propData) {

  var _self = this,marker,
    propertyTypeLabel,
    propMarkerLabel,
    propertyBedMarkerLabel,
    propertyTypeLabelClass,
    markerHtml = '',
    dupPropData = propData;
    dupPropDataLength = dupPropData.length,
    propertyTypeLabelArr = [],indexArr = [],
    data = _self.markerData.properties;

  var pos = _self.createLatLngObject(data[dupPropData[0].split("|")[1]].lat, data[dupPropData[0].split("|")[1]].longitude);
  if(parseFloat(data[dupPropData[0].split("|")[1]].lat) && parseFloat(data[dupPropData[0].split("|")[1]].longitude)) {
    _self.locations.extend(pos);
  }

  $.each(dupPropData, function(i,value){
    propertyTypeLabelArr.push(data[value.split("|")[1]].propertyType);
  });

  if(propertyTypeLabelArr.indexOf(_self.markerData.propertyTypes["newUpperCaseLabel"]) > 0) {
    var splicedArr = dupPropData.splice(propertyTypeLabelArr.indexOf(_self.markerData.propertyTypes["newUpperCaseLabel"]),1);
    dupPropData.unshift(splicedArr[0]);
  }

  if(propertyTypeLabelArr.indexOf(_self.markerData.propertyTypes["newUpperCaseLabel"])==-1 &&  propertyTypeLabelArr.indexOf(_self.markerData.propertyTypes["lowUpperCaseLabel"]) > 0 ) {
    var splicedArr = dupPropData.splice(propertyTypeLabelArr.indexOf(_self.markerData.propertyTypes["lowUpperCaseLabel"]),1);
    dupPropData.unshift(splicedArr[0]);
  }
  
  var index, markerLabel;
  for(var i = 0; i < dupPropDataLength; i++) {

    index = dupPropData[i].split("|")[1]*1;

    if(data[index].marshaCode.toUpperCase() === dupPropData[i].split("|")[0].toUpperCase()){

      indexArr.push(index);
      if(_self.markerData.isHotelPin) {
        markerLabel = data[index].hotelName.slice(0,MapConfig.markerProps.hotelLength);
      } else {
        markerLabel = data[index].points || (data[index].symbol && getSymbolFromCurrency(data[index].symbol) || "") + (data[index].price || "");
      }
      propertyTypeLabel = data[index].propertyType || '';
      propMarkerLabel = data[index].propMarkerLabel;
      propertyBedMarkerLabel = data[index].propMarkerBedLabel;
      
      propertyTypeLabelClass = Object.keys(MapConfig.markerProps.propertyTypes).find(function(key){
        return MapConfig.markerProps.propertyTypes[key] === propertyTypeLabel ? true : false;
      }) || 'default';

      if(MapConfig.markerProps.propertyBedMarkerLabel['openingSoonUpperCaseLabel'] == propertyBedMarkerLabel) {
        propertyTypeLabelClass += ' ' + 'openingSoonUpperCaseLabel';
      } else if(MapConfig.markerProps.propertyBedMarkerLabel['callToBookUpperCaseLabel'] == propertyBedMarkerLabel) {
        propertyTypeLabelClass += ' ' + 'callToBookUpperCaseLabel';
      } else if(MapConfig.markerProps.propertyMarker['unavailableUpperCaseLabel'] == propMarkerLabel) {
        markerLabel = propMarkerLabel;
        propertyTypeLabelClass += ' ' + 'unavailableUpperCaseLabel';
      }  else if(!markerLabel) {
        propertyTypeLabelClass += ' blank';
        markerLabel = '';
      }

      markerHtml += '<div class="duplicate-map-marker map-marker map-marker-'+ propertyTypeLabelClass +'" data-propIndex = '+ index +'>' + (i == 0 ? '<span class="room-type m-merch-shape-3 m-merch-style-1">'+propertyTypeLabel+'</span>' : '') + '<div class="map-rate-details t-bg-standard-90 t-border-standard-10 t-border-color-standard-20">'+markerLabel +'<span class="t-icon-bedding t-color-standard-20"></span></div>' + (i == dupPropDataLength-1 ? '<div class="arrow t-bg-standard-standard-100 t-border-right t-border-bottom t-border-color-standard-20"></div>' : '') + '</div>'
    }
  }
 
  dupMarker = new this.markerWithLabel({
      position: pos,
      map: window.googleMaps,
      labelContent: markerHtml,
      icon: "test.png",
      labelAnchor: new google.maps.Point(40,40),
      markerIndex: indexArr,
      visible: !this.markerData.hideMarker,
      cursor: this.markerData.cursor,
      labelClass: "markerLabels"
  });
  this.omsList.addMarker(dupMarker);
  google.maps.event.addListener(dupMarker, 'mouseover', this.markerMouseOverHandler.bind(this, dupMarker));
  google.maps.event.addListener(dupMarker, 'mouseout',  this.markerMouseOutHandler.bind(this, dupMarker));

  return dupMarker;
},
  /**
  * This function is used to render google map clusters.
  * @return void
  **/
  renderClusters: function() {
    var _self = this;
    MapConfig.clusterProps.styles[0].url = this.markerData.imageUrl.clustImg;
    MapConfig.clusterProps.styles[0].fontFamily = "proxima-nova, Helvetica, Arial, sans-serif";
    MapConfig.clusterProps.styles[0].fontSize = "1rem";

    var markers = _.filter(this.markers, function(marker){
      if(marker) {
        return marker.position.lat() && marker.position.lng();
      }
    });
    if(!_self.isNoClusterView){
      this.markerCluster = new MarkerClusterer(window.googleMaps, markers, MapConfig.clusterProps);
      this.markerCluster.addMarkers(_self.duplicateMarkers);

      google.maps.event.addListener(this.markerCluster, "mouseover", function() {
        _self.isMarkerClusterHovered = true;
      });
      google.maps.event.addListener(this.markerCluster, "mouseout", function() {
        _self.isMarkerClusterHovered = false;
      });
    }
    this.setMapView();
  },

  /**
  * This function is used to style google map.
  * @return void
  **/
  generateStyledMap: function() {
    window.googleMaps.setOptions({styles: MapConfig.styledMapType});
  },

  /**
  * This function is used to create infowindow in google map.
  * @return void
  **/
  createInfoWindow: function() {
    var _self = this;
    this.infoWindow = new google.maps.InfoWindow();


    // Creation of the infoWindow HTML structure on domready state
    google.maps.event.addListener(this.infoWindow, 'domready', function() {
      var infoWindowOuter = $('.gm-style-iw');
      var infoWindowBackground = infoWindowOuter.prev();
      var infoWindowCloseBtn = infoWindowOuter.next();
      infoWindowBackground.remove();
      infoWindowCloseBtn.remove();
      infoWindowOuter.find('.m-property-name-address .m-result-hotel-title,.t-dotdotdot').dotdotdot();
      if (!_self.currentMarker.isAddressPin) {
        infoWindowOuter.parent().parent().addClass('custom-info-window');
      } else {
        infoWindowOuter.parent().parent().addClass('address-info-window');
        infoWindowOuter.addClass('address-info-window-center-align');
      }
    });

  },

  /**
  * This function is used to intiate google map.
  * @return void
  **/
  renderApi: function() {
    this.oms = require('overlapping-marker-spiderfier');
    if(MapConfig.customControl) {
      this.markerWithLabel= require('markerwithlabel')(google.maps);
    }
    this.renderGoogleMap();
    this.renderMarkers();
    this.renderClusters();
    this.generateStyledMap();
    this.createInfoWindow();
  },

  /**
  * This function is used to set the google map on initial load
  */
  setMapView: function() {
    var latlngList = this.markerData.properties;
    if (latlngList[0].isHwsPin) {
      window.googleMaps.setCenter(new google.maps.LatLng(latlngList[0].lat, latlngList[0].longitude));
      window.googleMaps.setZoom(MapConfig.mapProps.zoom);
    }
    else if (latlngList.length == 1) {
      window.googleMaps.setCenter(new google.maps.LatLng(latlngList[0].lat, latlngList[0].longitude));
      window.googleMaps.setZoom(MapConfig.markerZoomLevel);
    } else if (latlngList.length == 0) {
      window.googleMaps.setCenter(new google.maps.LatLng(MapConfig.defaultLat,MapConfig.defaultLong));
      window.googleMaps.setZoom(MapConfig.mapProps.zoom);
    } else {
      window.googleMaps.fitBounds(this.locations);
    }
  },
  /**
  * This function is used to handle the click event on marker.
  * @param {Object} marker on which Mouse event triggered.
  * @return void
  **/
  markerClickHandler: function(marker,event,markerArrayIndex) {
     // set infowindow persistence
    if (this.markerData.persistInfoWindowOnClick) {
      $(this.getMapEl()).addClass('mi-flyout-style-wrap');
      this.isInfoWindowPersist = true;
    }
    this.pubsub.publish('GOOGLE_MAP_MARKER_EVENTS', [Constants.GLOBAL.MOUSE_CLICK_EVENT, marker, this.infoWindow, markerArrayIndex]);
  },

  /**
  * This function is used to handle the mouseover event on marker.
  * @param {Object} marker on which Mouse event triggered.
  * @return void
  **/
  markerMouseOverHandler: function(marker) {
    // dont proceed if infowindow is already opened
    if (this.markerData.persistInfoWindowOnClick && this.isInfoWindowPersist) {
      return;
    }
    $('.gm-style-iw').parent().parent().removeClass('custom-info-window');
    this.pubsub.publish('GOOGLE_MAP_MARKER_EVENTS', [Constants.GLOBAL.MOUSE_OVER_EVENT, marker, this.infoWindow]);
    $(this.getMapEl()).addClass('mi-flyout-style-wrap');
  },

  /**
  * This function is used to handle the mouseout event on marker.
  * @param {Object} marker on which Mouse event triggered.
  * @return void
  **/
  markerMouseOutHandler: function(marker) {
    // dont proceed if infowindow is already opened
    if (this.markerData.persistInfoWindowOnClick && this.isInfoWindowPersist) {
      return;
    }

    this.pubsub.publish('GOOGLE_MAP_MARKER_EVENTS', [Constants.GLOBAL.MOUSE_OUT_EVENT, marker, this.infoWindow]);
    $(this.getMapEl()).removeClass('mi-flyout-style-wrap');
  },

  /**
   * Returns property records map elemnt
   * @returns {Object} - Google map container element
   */
  getMapEl: function() {
    return window.googleMaps.getDiv();
  },

  /**
   * Returns property records map object
   * @returns {Object} - Google map instance
   */
  getMap: function() {
    return window.googleMaps;
  },

  /**
   * Returns current map lat/lng bound
   * @returns {Object} - Google latlng bound instance
   */
  getLatLngBounds: function() {
    return this.locations;
  },

  /**
   * Add marker on the map
   * @param {Object} markerOptions - Google map marker options
   * @returns {Object} - Google map marker instance
   */
  addMarker: function(markerOptions) {
    if(MapConfig.customControl)  {
      return new this.markerWithLabel(markerOptions)
    } else {
      return new google.maps.Marker(markerOptions); 
    } 
  },

  /**
   * Set markers visibility
   */
  setMarkersVisible: function(visible) {
    this.markers.forEach(function(marker) {
      marker.setVisible(visible);
    });
  },

  /**
   * Remove markers from cluster
   */
  clearMarkersCluster: function() {
    if(!this.isNoClusterView){
      this.markerCluster.clearMarkers();
    }
  },

  /**
   * Add markers to cluster
   */
  addMarkersCluster: function() {
    var markers = this.markers.filter(function(marker) { return marker.position.lat() && marker.position.lng();});
    if(!this.isNoClusterView){
      this.markerCluster.addMarkers(markers);
    }
  }
};

module.exports = {
  create: function(props) {
    var obj = _.cloneDeep(properties);
    var GoogleMapInstance = componentMapper.extend(obj);
    return new GoogleMapInstance(props);
  }
};
